import React, { useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import MinusIcon from '../../imgs/minus-icon.svg';
import PlusIcon from '../../imgs/plus-icon.svg';

const CustomAccordion = ({ items }) => {
    const [activeKey, setActiveKey] = useState(null);

    const handleToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };

    return (
        <Accordion activeKey={activeKey} onSelect={handleToggle}>
            {items.map((item, index) => (
                <Card key={index}>
                    <Card.Header>
                        <Button 
                            variant="link" 
                            onClick={() => handleToggle(index)} 
                            aria-controls={`accordion-body-${index}`} 
                            aria-expanded={activeKey === index} 
                            className="d-flex justify-content-between align-items-center"
                        >
                            <span className="title">{item.title}</span>
                            <span>
                                <img 
                                    src={activeKey === index ? MinusIcon : PlusIcon} 
                                    alt={activeKey === index ? "Collapse" : "Expand"} 
                                />
                            </span>
                        </Button>
                    </Card.Header>
                    <Accordion.Collapse eventKey={index}>
                        <Card.Body>{item.content}</Card.Body>
                    </Accordion.Collapse>
                </Card>
            ))}
        </Accordion>
    );
};

export default CustomAccordion;
